//@flow
import _ from 'lodash';
import * as React from 'react';
import { FormGroup } from 'reactstrap';
import { objectsConstants } from '../../_constants/objects.constants';
import { formatterHelper } from '../../_helpers/formatter.helper';
import { estabelecimentoFinanceiroService } from '../../_services/estabelecimentoFinanceiro.service';
import FormSelectInput from '../../components/inputs/FormSelectInput';
import SelectInput from '../../components/inputs/SelectInput';
import FormInput from './../../components/inputs/FormInput';
import { empresaFinanceiroService } from '../../_services/empresaFinanceiro.service';
import { perfilservice } from '../../_services/perfil.service';


type Props = { onChangeText: any, entity: any, onChangeValue: any };

export default class UsuarioFinanceiroListFilter extends React.PureComponent<Props> {
  render() {
    const { entity } = this.props;
    return (
      <React.Fragment>
        <FormGroup className="col-12 col-xl-4">
          <FormInput
            label="Nome do usuário"
            placeholder={'Nome'}
            id={'namefilter'}
            name="nome"
            onChange={this.props.onChangeDate}
            type={'text'}
            size={12}
            style={'col-12 col-sm-4 offset-sm-1'}
            value={entity.nome}
          />
        </FormGroup>
        <FormGroup className="col-12 col-xl-2">
          <FormInput
            label="CPF"
            placeholder={'CPF'}
            id={'cpfCnpj'}
            name="cpfCnpj"
            onChange={this.props.onChangeDate}
            type={'text'}
            size={12}
            style={'col-12 col-sm-4'}
            value={entity.cpfCnpj}
          />
        </FormGroup>
        <FormGroup className="col-12 col-xl-3">
          <FormSelectInput
            onChange={this.props.onChangeDate}
            id="empresa"
            label="Empresa"
            placeholder="Empresa"
            name="empresa"
            value={entity.empresa}
            returnFullObject={true}
            service={empresaFinanceiroService.findAll}
            creatable={false}
            isMulti={false}
            valueKey="id"
            labelKey="nome"
          />
        </FormGroup>
        <FormGroup className="col-12 col-xl-3">
          <FormSelectInput
            onChange={this.props.onChangeDate}
            id="estabelecimento"
            label="Estabelecimento"
            placeholder="Estabelecimento"
            name="estabelecimento"
            value={entity.estabelecimento}
            returnFullObject={true}
            service={estabelecimentoFinanceiroService.findAll}
            creatable={false}
            isMulti={false}
            valueKey="id"
            labelKey="nome"
          />
        </FormGroup>
        <FormGroup className="col-12 col-xl-3">
          <FormSelectInput
            label={'Perfil'}
            id="userRole"
            name="userRole"
            placeholder="Perfil"
            value={_.get(entity, 'userRole')}
            onChange={this.props.onChangeDate}
            noSize={true}
            required={false}
            returnFullObject={true}
            valueKey={'name'}
            labelKey={'description'}
            multi={false}
            service={perfilservice.findAllFinanceiro}
            defaultValue={_.get(entity, 'userRole.description')}
          />
        </FormGroup>

        <FormGroup className="col-12 col-xl-3">
          <SelectInput
            id={'origem'}
            options={[
              { label: 'SASC CM', value: 'SISTEMA' },
              { label: 'MetaDoctor', value: 'SSO_META' },
            ]}
            returnFullObject={false}
            label="Origem do cadastro"
            labelKey={'label'}
            valueKey={'value'}
            name={'origem'}
            value={entity.origem}
            onChange={(name, value) => {
              this.props.onChangeDate(name, value)
            }
            }
          />
        </FormGroup>

        <FormGroup className="col-12 col-xl-2">
          <SelectInput
            id={'status'}
            options={[
              { label: 'Sim', value: true },
              { label: 'Não', value: false },
            ]}
            returnFullObject={true}
            label="Ativo?"
            labelKey={'label'}
            valueKey={'value'}
            name={'status'}
            value={
              _.isBoolean(entity.status)
                ? formatterHelper.getEnum(
                  entity.status,
                  objectsConstants.SIM_NAO
                )
                : entity.status
            }
            onChange={(name, value) => {
              this.props.onChangeDate(name, value.value)
            }
            }
          />
        </FormGroup>

      </React.Fragment>
    );
  }
}
